import type { Components, Theme } from "@mui/material";

export const cardHeaderTheme: Components<Theme>["MuiCardHeader"] = {
  styleOverrides: {
    root: () => ({
      alignItems: "center",
    }),
    title: ({ theme }) => ({
      fontSize: theme.typography.body1.fontSize,
      fontWeight: 600,
    }),
    avatar: ({ theme }) => ({
      marginRight: theme.spacing(1.5),
    }),
  },
};
